import { Box, Typography, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../Button/CustomButton";

interface modalProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
}

const AsscessDeniedModal: React.FC<modalProps> = ({ setOpen }) => {

return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#eff4f7",
          borderRadius: "10px",
          padding: "48px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton
          sx={{ position: "absolute", top: 12, right: 12, fontSize: "24px" }}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFFFFf",
            borderRadius: "10px",
            padding: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              color: "info.main",
              p: "20px",
              fontSize: "16px",
            }}
          >
          Exit Denied
          </Typography>
          <Box
            sx={{
              backgroundColor: "#cac7c7",
              height: "0.5px",
              width: "500px",
            }}
          />
          <br/>
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "start",
              fontWeight: 400,
              fontSize: "12px",
              color: "#636060",
              p: "10px 10px 30px 10px ",
              width: "500px",
            }}
          >
           You cannot exit while taking test. To ensure the integrity of the assessment, exiting is restricted until the test is completed.
          </Typography>
          <Typography
            sx={{
              display: "flex",
              alignItems: "center",
              textAlign: "start",
              fontWeight: 400,
              fontSize: "12px",
              color: "#636060",
              p: "0px 10px 30px 10px ",
              width: "500px",
            }}
          >
          Please focus on finishing the test.
          </Typography>
          <Box
            sx={{
              backgroundColor: "#646262",
              height: "0.3px",
              width: "500px",
            }}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: "20px",
              width: "100%",
            }}
          >
            <CustomButton
              name="Continue"
              variant="primary"
              // padding="5px 10px 5px 10px"
              onClick={() => setOpen(false)}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AsscessDeniedModal;
